<div class="modal-header">
  <h4 class="modal-title">Test</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>    
    <div class="form-group" style="font-size:14px;">
      <div class="input-group">
        <label>Event End Date:</label>&nbsp;
        <input id="endDate" class="form-control" placeholder="yyyy-mm-dd" name="ass" ngbDatepicker #dp="ngbDatepicker">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary fa fa-calendar" (click)="dp.toggle()" type="button"></button>
        </div>
      </div>      
    </div>    
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Save</button>
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Cancel click')">Cancel</button>
</div>
